function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { defineComponent, openBlock, createElementBlock, createElementVNode, unref } from 'vue';
import '../../../hooks/index.mjs';
import _export_sfc from '../../../_virtual/plugin-vue_export-helper.mjs';
import { useNamespace } from '../../../hooks/use-namespace/index.mjs';
import { useId } from '../../../hooks/use-id/index.mjs';
const _hoisted_1 = {
  viewBox: "0 0 79 86",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
};
const _hoisted_2 = ["id"];
const _hoisted_3 = ["stop-color"];
const _hoisted_4 = ["stop-color"];
const _hoisted_5 = ["id"];
const _hoisted_6 = ["stop-color"];
const _hoisted_7 = ["stop-color"];
const _hoisted_8 = ["id"];
const _hoisted_9 = {
  id: "Illustrations",
  stroke: "none",
  "stroke-width": "1",
  fill: "none",
  "fill-rule": "evenodd"
};
const _hoisted_10 = {
  id: "B-type",
  transform: "translate(-1268.000000, -535.000000)"
};
const _hoisted_11 = {
  id: "Group-2",
  transform: "translate(1268.000000, 535.000000)"
};
const _hoisted_12 = ["fill"];
const _hoisted_13 = ["fill"];
const _hoisted_14 = {
  id: "Group-Copy",
  transform: "translate(34.500000, 31.500000) scale(-1, 1) rotate(-25.000000) translate(-34.500000, -31.500000) translate(7.000000, 10.000000)"
};
const _hoisted_15 = ["fill"];
const _hoisted_16 = ["fill"];
const _hoisted_17 = ["fill"];
const _hoisted_18 = ["fill"];
const _hoisted_19 = ["fill"];
const _hoisted_20 = {
  id: "Rectangle-Copy-17",
  transform: "translate(53.000000, 45.000000)"
};
const _hoisted_21 = ["fill", "xlink:href"];
const _hoisted_22 = ["fill", "mask"];
const _hoisted_23 = ["fill"];
const __default__ = defineComponent({
  name: "ImgEmpty"
});
const _sfc_main = /* @__PURE__ */defineComponent(_objectSpread(_objectSpread({}, __default__), {}, {
  setup(__props) {
    const ns = useNamespace("empty");
    const id = useId();
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("svg", _hoisted_1, [createElementVNode("defs", null, [createElementVNode("linearGradient", {
        id: `linearGradient-1-${unref(id)}`,
        x1: "38.8503086%",
        y1: "0%",
        x2: "61.1496914%",
        y2: "100%"
      }, [createElementVNode("stop", {
        "stop-color": `var(${unref(ns).cssVarBlockName("fill-color-1")})`,
        offset: "0%"
      }, null, 8, _hoisted_3), createElementVNode("stop", {
        "stop-color": `var(${unref(ns).cssVarBlockName("fill-color-4")})`,
        offset: "100%"
      }, null, 8, _hoisted_4)], 8, _hoisted_2), createElementVNode("linearGradient", {
        id: `linearGradient-2-${unref(id)}`,
        x1: "0%",
        y1: "9.5%",
        x2: "100%",
        y2: "90.5%"
      }, [createElementVNode("stop", {
        "stop-color": `var(${unref(ns).cssVarBlockName("fill-color-1")})`,
        offset: "0%"
      }, null, 8, _hoisted_6), createElementVNode("stop", {
        "stop-color": `var(${unref(ns).cssVarBlockName("fill-color-6")})`,
        offset: "100%"
      }, null, 8, _hoisted_7)], 8, _hoisted_5), createElementVNode("rect", {
        id: `path-3-${unref(id)}`,
        x: "0",
        y: "0",
        width: "17",
        height: "36"
      }, null, 8, _hoisted_8)]), createElementVNode("g", _hoisted_9, [createElementVNode("g", _hoisted_10, [createElementVNode("g", _hoisted_11, [createElementVNode("path", {
        id: "Oval-Copy-2",
        d: "M39.5,86 C61.3152476,86 79,83.9106622 79,81.3333333 C79,78.7560045 57.3152476,78 35.5,78 C13.6847524,78 0,78.7560045 0,81.3333333 C0,83.9106622 17.6847524,86 39.5,86 Z",
        fill: `var(${unref(ns).cssVarBlockName("fill-color-3")})`
      }, null, 8, _hoisted_12), createElementVNode("polygon", {
        id: "Rectangle-Copy-14",
        fill: `var(${unref(ns).cssVarBlockName("fill-color-7")})`,
        transform: "translate(27.500000, 51.500000) scale(1, -1) translate(-27.500000, -51.500000) ",
        points: "13 58 53 58 42 45 2 45"
      }, null, 8, _hoisted_13), createElementVNode("g", _hoisted_14, [createElementVNode("polygon", {
        id: "Rectangle-Copy-10",
        fill: `var(${unref(ns).cssVarBlockName("fill-color-7")})`,
        transform: "translate(11.500000, 5.000000) scale(1, -1) translate(-11.500000, -5.000000) ",
        points: "2.84078316e-14 3 18 3 23 7 5 7"
      }, null, 8, _hoisted_15), createElementVNode("polygon", {
        id: "Rectangle-Copy-11",
        fill: `var(${unref(ns).cssVarBlockName("fill-color-5")})`,
        points: "-3.69149156e-15 7 38 7 38 43 -3.69149156e-15 43"
      }, null, 8, _hoisted_16), createElementVNode("rect", {
        id: "Rectangle-Copy-12",
        fill: `url(#linearGradient-1-${unref(id)})`,
        transform: "translate(46.500000, 25.000000) scale(-1, 1) translate(-46.500000, -25.000000) ",
        x: "38",
        y: "7",
        width: "17",
        height: "36"
      }, null, 8, _hoisted_17), createElementVNode("polygon", {
        id: "Rectangle-Copy-13",
        fill: `var(${unref(ns).cssVarBlockName("fill-color-2")})`,
        transform: "translate(39.500000, 3.500000) scale(-1, 1) translate(-39.500000, -3.500000) ",
        points: "24 7 41 7 55 -3.63806207e-12 38 -3.63806207e-12"
      }, null, 8, _hoisted_18)]), createElementVNode("rect", {
        id: "Rectangle-Copy-15",
        fill: `url(#linearGradient-2-${unref(id)})`,
        x: "13",
        y: "45",
        width: "40",
        height: "36"
      }, null, 8, _hoisted_19), createElementVNode("g", _hoisted_20, [createElementVNode("use", {
        id: "Mask",
        fill: `var(${unref(ns).cssVarBlockName("fill-color-8")})`,
        transform: "translate(8.500000, 18.000000) scale(-1, 1) translate(-8.500000, -18.000000) ",
        "xlink:href": `#path-3-${unref(id)}`
      }, null, 8, _hoisted_21), createElementVNode("polygon", {
        id: "Rectangle-Copy",
        fill: `var(${unref(ns).cssVarBlockName("fill-color-9")})`,
        mask: `url(#mask-4-${unref(id)})`,
        transform: "translate(12.000000, 9.000000) scale(-1, 1) translate(-12.000000, -9.000000) ",
        points: "7 0 24 0 20 18 7 16.5"
      }, null, 8, _hoisted_22)]), createElementVNode("polygon", {
        id: "Rectangle-Copy-18",
        fill: `var(${unref(ns).cssVarBlockName("fill-color-2")})`,
        transform: "translate(66.000000, 51.500000) scale(-1, 1) translate(-66.000000, -51.500000) ",
        points: "62 45 79 45 70 58 53 58"
      }, null, 8, _hoisted_23)])])])]);
    };
  }
}));
var ImgEmpty = /* @__PURE__ */_export_sfc(_sfc_main, [["__file", "img-empty.vue"]]);
export { ImgEmpty as default };